import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import Quality from "@/components/site/Quality";
import Process from "@/components/site/Process";
import Academy from "@/components/site/Academy";
import Dashboard from "@/components/site/Dashboard";
import Values from "@/components/site/Values";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import CookieBanner from "@/components/site/CookieBanner";

export default function Home() {
  return (
    <div className="min-h-screen bg-white" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Services />
        <Quality />
        <Process />
        <Academy />
        <Dashboard />
        <Values />
        <Contact />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
